// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-history-panel {
    /* position: fixed; ここがfixedだとなぜか背景が透明なる */
    top: 0;
    right: 0;
    width: 400px;
    height: 100%;
    background-color: var(--surface01);
    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    z-index: 310;
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
}

.chat-history-panel.visible {
    transform: translateX(0);
}

.chat-history-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    padding: 14px 16px;
    border-bottom: 1px solid var(--border, var(--surface02));
    background-color: var(--surface, var(--surface01));
}

/* すべて / ユーザー / AI フィルタ */
.chat-history-filter {
    display: inline-flex;
    gap: 4px;
    background: var(--surface-2, var(--surface02, rgba(255, 255, 255, .05)));
    border: 1px solid var(--border, transparent);
    border-radius: 999px;
    padding: 3px;
}

.chf-btn {
    background: none;
    border: 0;
    cursor: pointer;
    font-size: 11px;
    font-weight: 600;
    color: var(--text-dim, var(--text02, #98a2b8));
    padding: 5px 10px;
    border-radius: 999px;
    line-height: 1;
}

.chf-btn.on {
    color: #fff;
}

.chf-btn.chf-all.on {
    background: #66708c;
}

.chf-btn.chf-user.on {
    background: #3ad29f;
    color: #04231a;
}

.chf-btn.chf-ai.on {
    background: var(--accent, #4aa8ff);
}

.chat-history-title {
    font-size: 18px;
    font-weight: 600;
    color: var(--text01);
}

.chat-history-close {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: var(--icon01);
    padding: 4px 8px;
}

.chat-history-close:hover {
    color: var(--icon01Hover);
}

.chat-history-conversation-selector {
    padding: 16px;
    border-bottom: 1px solid var(--surface02);
}

.chat-history-select {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid var(--surface03);
    border-radius: 4px;
    background-color: var(--surface01);
    color: var(--text01);
    font-size: 14px;
    cursor: pointer;
}

.chat-history-select:hover {
    border-color: var(--action01);
}

/* ヘッダー＋フィルタ行のラッパー。PC では display:contents で「無かったこと」に
   なるため、従来どおり2段レイアウトのまま。スマホでのみ1本の flex 行にする。 */
.chat-history-topbar {
    display: contents;
}

/* ヘッダー右の「AI評価」アクションボタン（フィルタとは別扱い） */
.chf-feedback {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    flex: 0 0 auto;
    background: var(--accent, #4aa8ff);
    border: 0;
    border-radius: 999px;
    color: #fff;
    cursor: pointer;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    padding: 8px 14px;
    white-space: nowrap;
}

.chf-feedback:hover:not(:disabled) {
    filter: brightness(1.08);
}

.chf-feedback:disabled {
    opacity: .55;
    cursor: default;
}

/* AI評価レポート未読バッジ（赤ドット）。スライドを開くと消える。 */
.chf-feedback-badge {
    position: absolute;
    top: -3px;
    right: -3px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #ff3b30;
    border: 2px solid var(--surface, var(--surface01));
    box-shadow: 0 0 0 1px rgba(0, 0, 0, .15);
    animation: chf-feedback-pulse 1.4s ease-in-out infinite;
}

@keyframes chf-feedback-pulse {
    0%, 100% { transform: scale(1); opacity: 1; }
    50% { transform: scale(1.35); opacity: .7; }
}

/* フィルタ（すべて/ユーザー/AI）はヘッダー下の独立バーに配置 */
.chat-history-subbar {
    display: flex;
    align-items: center;
    padding: 8px 16px;
    border-bottom: 1px solid var(--border, var(--surface02));
}

.chat-history-content {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
}

/* 会話履歴パネル最下部の送信入力（旧チャットボタンの代替）*/
.chat-history-input {
    display: flex;
    gap: 8px;
    padding: 12px;
    border-top: 1px solid var(--border, var(--surface02));
    background: var(--surface, var(--surface01));
}

.chat-history-input input {
    flex: 1;
    min-width: 0;
    padding: 9px 12px;
    border-radius: 999px;
    border: 1px solid var(--border, var(--surface03, rgba(255, 255, 255, .15)));
    background: var(--surface-2, var(--surface02, rgba(255, 255, 255, .05)));
    color: var(--text, var(--text01, #e8ebf2));
    font-size: 13.5px;
    outline: none;
}

.chat-history-input input::placeholder {
    color: var(--text-dim, var(--text02, #98a2b8));
}

.chat-history-input input:focus {
    border-color: var(--accent, #4aa8ff);
}

.chat-history-input button {
    flex: 0 0 auto;
    width: 38px;
    height: 38px;
    border: 0;
    border-radius: 50%;
    cursor: pointer;
    background: var(--accent, #4aa8ff);
    color: var(--on-accent, #fff);
    font-size: 14px;
    line-height: 1;
}

.chat-history-input button:disabled {
    opacity: .45;
    cursor: default;
}

.chat-history-polling {
    padding: 8px 16px;
    background-color: var(--surface02);
    color: var(--text02);
    font-size: 12px;
    text-align: center;
    border-bottom: 1px solid var(--surface03);
}

.chat-history-message {
    margin-bottom: 16px;
    padding: 12px;
    border-radius: 8px;
    background-color: var(--surface02);
    transition: background-color 0.3s ease;
}

.chat-history-message.new {
    background-color: rgba(255, 235, 59, 0.1);
    animation: highlight 2s ease-out;
}

@keyframes highlight {
    0% {
        background-color: rgba(255, 235, 59, 0.3);
    }
    100% {
        background-color: rgba(255, 235, 59, 0.1);
    }
}

.chat-history-message-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.chat-history-sender {
    font-weight: 600;
    color: var(--text01);
    display: flex;
    align-items: center;
    gap: 8px;
}

.chat-history-new-indicator {
    font-size: 12px;
}

.chat-history-action {
    font-size: 12px;
    padding: 2px 8px;
    border-radius: 12px;
    color: white;
    font-weight: 500;
}

.chat-history-action.text {
    background-color: #0066cc;
}

.chat-history-action.nod {
    background-color: #28a745;
}

.chat-history-action.store {
    background-color: #ffc107;
}

.chat-history-action.other {
    background-color: #6c757d;
}

.chat-history-message-text {
    color: var(--text01);
    margin-bottom: 4px;
    word-wrap: break-word;
}

.chat-history-timestamp {
    font-size: 12px;
    color: var(--text02);
}

.chat-history-loading {
    text-align: center;
    padding: 20px;
    color: var(--text02);
}

.chat-history-error {
    text-align: center;
    padding: 20px;
    color: var(--text04);
}

.chat-history-empty {
    text-align: center;
    padding: 20px;
    color: var(--text02);
}

.conversation-title-highlight {
    font-weight: bold;
}

/* ── Live STT transcript ────────────────────────────────────────────────────
   Theme-aware via var(--…, fallback): uses the DeepAI theme tokens when a
   theme is active, otherwise the Jitsi base tokens / literals. */
.stt-line {
    margin-bottom: 12px;
    padding: 10px 12px;
    border-radius: var(--radius-sm, 8px);
    background: var(--surface-2, var(--surface02, rgba(255, 255, 255, .04)));
    border: 1px solid var(--border, transparent);
}

.stt-line__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 4px;
}

.stt-line__name {
    font-weight: 600;
    font-size: 13px;
    color: var(--text, var(--text01, #e8ebf2));
}

.stt-line__time {
    font-size: 11px;
    color: var(--text-dim, var(--text02, #98a2b8));
}

.stt-line__text {
    color: var(--text, var(--text01, #e8ebf2));
    font-size: 14px;
    line-height: 1.5;
    word-wrap: break-word;
}

/* 途中結果: 淡色・斜体・認識中バッジ・点滅キャレット */
.stt-line--interim {
    background: transparent;
    border: 1px dashed var(--border, rgba(255, 255, 255, .18));
    opacity: .85;
}

.stt-line--interim .stt-line__text {
    font-style: italic;
    color: var(--text-dim, var(--text02, #98a2b8));
}

/* ── 案B: 話者グルーピング（レーン）────────────────────────────────────────
   連続する同一話者を1ブロックにまとめ、左の縦レーン色で AI / ユーザーを識別。 */
.stt-group {
    position: relative;
    margin-bottom: 14px;
    padding-left: 26px;
}

.stt-group::before {
    content: "";
    position: absolute;
    left: 7px;
    top: 22px;
    bottom: 2px;
    width: 2px;
    border-radius: 2px;
    background: var(--border, rgba(140, 165, 230, .3));
}

.stt-group--ai::before {
    background: var(--accent, #4aa8ff);
}

.stt-group--user::before {
    background: #3ad29f;
}

.stt-group__head {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: -26px;
    margin-bottom: 6px;
    font-size: 12px;
    font-weight: 700;
}

.stt-group--ai .stt-group__name {
    color: var(--accent, #4aa8ff);
}

.stt-group--user .stt-group__name {
    color: #3ad29f;
}

.stt-group__time {
    font-size: 10px;
    font-weight: 500;
    color: var(--text-dim, var(--text02, #98a2b8));
}

.stt-group__line {
    font-size: 13.5px;
    line-height: 1.55;
    margin-bottom: 5px;
    color: var(--text, var(--text01, #e8ebf2));
    word-wrap: break-word;
}

/* AI発話は圧を下げるため少し控えめの本文色 */
.stt-group--ai .stt-group__line {
    color: var(--text-dim, var(--text02, #b9c3e0));
}

.stt-group--live {
    opacity: .92;
}

/* AI返答: アクセント色寄りのバブルで区別 */
.stt-line--ai {
    background: var(--surface-2, rgba(70, 120, 255, .10));
    border-color: var(--accent, rgba(90, 150, 255, .45));
    box-shadow: inset 3px 0 0 0 var(--accent, #4aa8ff);
}

.stt-line--ai .stt-line__name {
    color: var(--accent, #4aa8ff);
}

.stt-live-badge {
    font-size: 11px;
    font-weight: 700;
    color: var(--accent, #4aa8ff);
    white-space: nowrap;
}

.stt-caret {
    display: inline-block;
    margin-left: 2px;
    color: var(--accent, #4aa8ff);
    animation: stt-caret-blink 1s steps(2, start) infinite;
}

@keyframes stt-caret-blink {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}`, "",{"version":3,"sources":["webpack://./react/features/chat_history/components/web/chat-history-panel.css"],"names":[],"mappings":"AAAA;IACI,0CAA0C;IAC1C,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,kCAAkC;IAClC,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,2BAA2B;IAC3B,sCAAsC;AAC1C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,wDAAwD;IACxD,kDAAkD;AACtD;;AAEA,yBAAyB;AACzB;IACI,oBAAoB;IACpB,QAAQ;IACR,wEAAwE;IACxE,4CAA4C;IAC5C,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,8CAA8C;IAC9C,iBAAiB;IACjB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kCAAkC;IAClC,kBAAkB;IAClB,kCAAkC;IAClC,oBAAoB;IACpB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;8CAC8C;AAC9C;IACI,iBAAiB;AACrB;;AAEA,oCAAoC;AACpC;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,kCAAkC;IAClC,SAAS;IACT,oBAAoB;IACpB,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA,qCAAqC;AACrC;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,kDAAkD;IAClD,wCAAwC;IACxC,uDAAuD;AAC3D;;AAEA;IACI,WAAW,mBAAmB,EAAE,UAAU,EAAE;IAC5C,MAAM,sBAAsB,EAAE,WAAW,EAAE;AAC/C;;AAEA,oCAAoC;AACpC;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,wDAAwD;AAC5D;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,aAAa;AACjB;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,QAAQ;IACR,aAAa;IACb,qDAAqD;IACrD,4CAA4C;AAChD;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,2EAA2E;IAC3E,wEAAwE;IACxE,0CAA0C;IAC1C,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,kCAAkC;IAClC,6BAA6B;IAC7B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kCAAkC;IAClC,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,kCAAkC;IAClC,sCAAsC;AAC1C;;AAEA;IACI,yCAAyC;IACzC,gCAAgC;AACpC;;AAEA;IACI;QACI,yCAAyC;IAC7C;IACA;QACI,yCAAyC;IAC7C;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;iEAEiE;AACjE;IACI,mBAAmB;IACnB,kBAAkB;IAClB,oCAAoC;IACpC,wEAAwE;IACxE,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,8CAA8C;AAClD;;AAEA;IACI,0CAA0C;IAC1C,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA,+BAA+B;AAC/B;IACI,uBAAuB;IACvB,0DAA0D;IAC1D,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;8CAC8C;AAC9C;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,8CAA8C;AAClD;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,0CAA0C;IAC1C,qBAAqB;AACzB;;AAEA,0BAA0B;AAC1B;IACI,8CAA8C;AAClD;;AAEA;IACI,YAAY;AAChB;;AAEA,0BAA0B;AAC1B;IACI,qDAAqD;IACrD,oDAAoD;IACpD,kDAAkD;AACtD;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,6BAA6B;IAC7B,sDAAsD;AAC1D;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":[".chat-history-panel {\n    /* position: fixed; ここがfixedだとなぜか背景が透明なる */\n    top: 0;\n    right: 0;\n    width: 400px;\n    height: 100%;\n    background-color: var(--surface01);\n    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);\n    display: flex;\n    flex-direction: column;\n    z-index: 310;\n    transform: translateX(100%);\n    transition: transform 0.3s ease-in-out;\n}\n\n.chat-history-panel.visible {\n    transform: translateX(0);\n}\n\n.chat-history-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n    padding: 14px 16px;\n    border-bottom: 1px solid var(--border, var(--surface02));\n    background-color: var(--surface, var(--surface01));\n}\n\n/* すべて / ユーザー / AI フィルタ */\n.chat-history-filter {\n    display: inline-flex;\n    gap: 4px;\n    background: var(--surface-2, var(--surface02, rgba(255, 255, 255, .05)));\n    border: 1px solid var(--border, transparent);\n    border-radius: 999px;\n    padding: 3px;\n}\n\n.chf-btn {\n    background: none;\n    border: 0;\n    cursor: pointer;\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--text-dim, var(--text02, #98a2b8));\n    padding: 5px 10px;\n    border-radius: 999px;\n    line-height: 1;\n}\n\n.chf-btn.on {\n    color: #fff;\n}\n\n.chf-btn.chf-all.on {\n    background: #66708c;\n}\n\n.chf-btn.chf-user.on {\n    background: #3ad29f;\n    color: #04231a;\n}\n\n.chf-btn.chf-ai.on {\n    background: var(--accent, #4aa8ff);\n}\n\n.chat-history-title {\n    font-size: 18px;\n    font-weight: 600;\n    color: var(--text01);\n}\n\n.chat-history-close {\n    background: none;\n    border: none;\n    font-size: 20px;\n    cursor: pointer;\n    color: var(--icon01);\n    padding: 4px 8px;\n}\n\n.chat-history-close:hover {\n    color: var(--icon01Hover);\n}\n\n.chat-history-conversation-selector {\n    padding: 16px;\n    border-bottom: 1px solid var(--surface02);\n}\n\n.chat-history-select {\n    width: 100%;\n    padding: 8px 12px;\n    border: 1px solid var(--surface03);\n    border-radius: 4px;\n    background-color: var(--surface01);\n    color: var(--text01);\n    font-size: 14px;\n    cursor: pointer;\n}\n\n.chat-history-select:hover {\n    border-color: var(--action01);\n}\n\n/* ヘッダー＋フィルタ行のラッパー。PC では display:contents で「無かったこと」に\n   なるため、従来どおり2段レイアウトのまま。スマホでのみ1本の flex 行にする。 */\n.chat-history-topbar {\n    display: contents;\n}\n\n/* ヘッダー右の「AI評価」アクションボタン（フィルタとは別扱い） */\n.chf-feedback {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    flex: 0 0 auto;\n    background: var(--accent, #4aa8ff);\n    border: 0;\n    border-radius: 999px;\n    color: #fff;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 1;\n    padding: 8px 14px;\n    white-space: nowrap;\n}\n\n.chf-feedback:hover:not(:disabled) {\n    filter: brightness(1.08);\n}\n\n.chf-feedback:disabled {\n    opacity: .55;\n    cursor: default;\n}\n\n/* AI評価レポート未読バッジ（赤ドット）。スライドを開くと消える。 */\n.chf-feedback-badge {\n    position: absolute;\n    top: -3px;\n    right: -3px;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background: #ff3b30;\n    border: 2px solid var(--surface, var(--surface01));\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, .15);\n    animation: chf-feedback-pulse 1.4s ease-in-out infinite;\n}\n\n@keyframes chf-feedback-pulse {\n    0%, 100% { transform: scale(1); opacity: 1; }\n    50% { transform: scale(1.35); opacity: .7; }\n}\n\n/* フィルタ（すべて/ユーザー/AI）はヘッダー下の独立バーに配置 */\n.chat-history-subbar {\n    display: flex;\n    align-items: center;\n    padding: 8px 16px;\n    border-bottom: 1px solid var(--border, var(--surface02));\n}\n\n.chat-history-content {\n    flex: 1;\n    overflow-y: auto;\n    padding: 16px;\n}\n\n/* 会話履歴パネル最下部の送信入力（旧チャットボタンの代替）*/\n.chat-history-input {\n    display: flex;\n    gap: 8px;\n    padding: 12px;\n    border-top: 1px solid var(--border, var(--surface02));\n    background: var(--surface, var(--surface01));\n}\n\n.chat-history-input input {\n    flex: 1;\n    min-width: 0;\n    padding: 9px 12px;\n    border-radius: 999px;\n    border: 1px solid var(--border, var(--surface03, rgba(255, 255, 255, .15)));\n    background: var(--surface-2, var(--surface02, rgba(255, 255, 255, .05)));\n    color: var(--text, var(--text01, #e8ebf2));\n    font-size: 13.5px;\n    outline: none;\n}\n\n.chat-history-input input::placeholder {\n    color: var(--text-dim, var(--text02, #98a2b8));\n}\n\n.chat-history-input input:focus {\n    border-color: var(--accent, #4aa8ff);\n}\n\n.chat-history-input button {\n    flex: 0 0 auto;\n    width: 38px;\n    height: 38px;\n    border: 0;\n    border-radius: 50%;\n    cursor: pointer;\n    background: var(--accent, #4aa8ff);\n    color: var(--on-accent, #fff);\n    font-size: 14px;\n    line-height: 1;\n}\n\n.chat-history-input button:disabled {\n    opacity: .45;\n    cursor: default;\n}\n\n.chat-history-polling {\n    padding: 8px 16px;\n    background-color: var(--surface02);\n    color: var(--text02);\n    font-size: 12px;\n    text-align: center;\n    border-bottom: 1px solid var(--surface03);\n}\n\n.chat-history-message {\n    margin-bottom: 16px;\n    padding: 12px;\n    border-radius: 8px;\n    background-color: var(--surface02);\n    transition: background-color 0.3s ease;\n}\n\n.chat-history-message.new {\n    background-color: rgba(255, 235, 59, 0.1);\n    animation: highlight 2s ease-out;\n}\n\n@keyframes highlight {\n    0% {\n        background-color: rgba(255, 235, 59, 0.3);\n    }\n    100% {\n        background-color: rgba(255, 235, 59, 0.1);\n    }\n}\n\n.chat-history-message-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.chat-history-sender {\n    font-weight: 600;\n    color: var(--text01);\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.chat-history-new-indicator {\n    font-size: 12px;\n}\n\n.chat-history-action {\n    font-size: 12px;\n    padding: 2px 8px;\n    border-radius: 12px;\n    color: white;\n    font-weight: 500;\n}\n\n.chat-history-action.text {\n    background-color: #0066cc;\n}\n\n.chat-history-action.nod {\n    background-color: #28a745;\n}\n\n.chat-history-action.store {\n    background-color: #ffc107;\n}\n\n.chat-history-action.other {\n    background-color: #6c757d;\n}\n\n.chat-history-message-text {\n    color: var(--text01);\n    margin-bottom: 4px;\n    word-wrap: break-word;\n}\n\n.chat-history-timestamp {\n    font-size: 12px;\n    color: var(--text02);\n}\n\n.chat-history-loading {\n    text-align: center;\n    padding: 20px;\n    color: var(--text02);\n}\n\n.chat-history-error {\n    text-align: center;\n    padding: 20px;\n    color: var(--text04);\n}\n\n.chat-history-empty {\n    text-align: center;\n    padding: 20px;\n    color: var(--text02);\n}\n\n.conversation-title-highlight {\n    font-weight: bold;\n}\n\n/* ── Live STT transcript ────────────────────────────────────────────────────\n   Theme-aware via var(--…, fallback): uses the DeepAI theme tokens when a\n   theme is active, otherwise the Jitsi base tokens / literals. */\n.stt-line {\n    margin-bottom: 12px;\n    padding: 10px 12px;\n    border-radius: var(--radius-sm, 8px);\n    background: var(--surface-2, var(--surface02, rgba(255, 255, 255, .04)));\n    border: 1px solid var(--border, transparent);\n}\n\n.stt-line__head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    margin-bottom: 4px;\n}\n\n.stt-line__name {\n    font-weight: 600;\n    font-size: 13px;\n    color: var(--text, var(--text01, #e8ebf2));\n}\n\n.stt-line__time {\n    font-size: 11px;\n    color: var(--text-dim, var(--text02, #98a2b8));\n}\n\n.stt-line__text {\n    color: var(--text, var(--text01, #e8ebf2));\n    font-size: 14px;\n    line-height: 1.5;\n    word-wrap: break-word;\n}\n\n/* 途中結果: 淡色・斜体・認識中バッジ・点滅キャレット */\n.stt-line--interim {\n    background: transparent;\n    border: 1px dashed var(--border, rgba(255, 255, 255, .18));\n    opacity: .85;\n}\n\n.stt-line--interim .stt-line__text {\n    font-style: italic;\n    color: var(--text-dim, var(--text02, #98a2b8));\n}\n\n/* ── 案B: 話者グルーピング（レーン）────────────────────────────────────────\n   連続する同一話者を1ブロックにまとめ、左の縦レーン色で AI / ユーザーを識別。 */\n.stt-group {\n    position: relative;\n    margin-bottom: 14px;\n    padding-left: 26px;\n}\n\n.stt-group::before {\n    content: \"\";\n    position: absolute;\n    left: 7px;\n    top: 22px;\n    bottom: 2px;\n    width: 2px;\n    border-radius: 2px;\n    background: var(--border, rgba(140, 165, 230, .3));\n}\n\n.stt-group--ai::before {\n    background: var(--accent, #4aa8ff);\n}\n\n.stt-group--user::before {\n    background: #3ad29f;\n}\n\n.stt-group__head {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-left: -26px;\n    margin-bottom: 6px;\n    font-size: 12px;\n    font-weight: 700;\n}\n\n.stt-group--ai .stt-group__name {\n    color: var(--accent, #4aa8ff);\n}\n\n.stt-group--user .stt-group__name {\n    color: #3ad29f;\n}\n\n.stt-group__time {\n    font-size: 10px;\n    font-weight: 500;\n    color: var(--text-dim, var(--text02, #98a2b8));\n}\n\n.stt-group__line {\n    font-size: 13.5px;\n    line-height: 1.55;\n    margin-bottom: 5px;\n    color: var(--text, var(--text01, #e8ebf2));\n    word-wrap: break-word;\n}\n\n/* AI発話は圧を下げるため少し控えめの本文色 */\n.stt-group--ai .stt-group__line {\n    color: var(--text-dim, var(--text02, #b9c3e0));\n}\n\n.stt-group--live {\n    opacity: .92;\n}\n\n/* AI返答: アクセント色寄りのバブルで区別 */\n.stt-line--ai {\n    background: var(--surface-2, rgba(70, 120, 255, .10));\n    border-color: var(--accent, rgba(90, 150, 255, .45));\n    box-shadow: inset 3px 0 0 0 var(--accent, #4aa8ff);\n}\n\n.stt-line--ai .stt-line__name {\n    color: var(--accent, #4aa8ff);\n}\n\n.stt-live-badge {\n    font-size: 11px;\n    font-weight: 700;\n    color: var(--accent, #4aa8ff);\n    white-space: nowrap;\n}\n\n.stt-caret {\n    display: inline-block;\n    margin-left: 2px;\n    color: var(--accent, #4aa8ff);\n    animation: stt-caret-blink 1s steps(2, start) infinite;\n}\n\n@keyframes stt-caret-blink {\n    0% {\n        opacity: 1;\n    }\n\n    100% {\n        opacity: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
